import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findGenders = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/genders${query}`, {
        headers
    })
}

export const countGenders = (headers, params) => {
    let query = buildQuery(params);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/genders/count${query}`, {
        headers
    })
}

export const findGenderById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/genders/${id}`, {
        headers
    })
}
